<template>
  <section>
    <modal-open-contact :dataCompanyModal="dataCompanyModal"/>
    <modal-password subtitle-modal="Digite a senha do admin para excluir a nota" title-modal="Excluir nota de NPS"
                    :run-function="removeNps"/>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'NPS'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Inicial</label>
                      <datepicker ref="programaticOpen3" v-model="dataSearch.init" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Final</label>
                      <datepicker ref="programaticOpen4" v-model="dataSearch.end" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">CompanyID</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="company"
                             name="company"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Nota abaixo de</label>
                      <input v-model="dataSearch.minRating" v-mask="'###'" type="text" class="form-control"
                             id="minRating" name="minRating" placeholder="Ex: 03"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Nota acima de</label>
                      <input v-model="dataSearch.rating" v-mask="'###'" type="text" class="form-control" id="rating"
                             name="rating" placeholder="Ex: 03"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">NPS respondido em X dias</label>
                      <input v-model="dataSearch.daysAnswered" v-mask="'###'" type="text" class="form-control"
                             id="daysAnswered" name="daysAnswered" placeholder="Ex: 10"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Tipo de nota</label>
                      <select v-model="dataSearch.noteType">
                        <option value="">Selecione</option>
                        <option value="1">Detrator</option>
                        <option value="2">Neutro</option>
                        <option value="3">Promotor</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Cliente na base até:</label>
                      <select v-model="dataSearch.clientBase">
                        <option value="">Selecione</option>
                        <option value="30">30</option>
                        <option value="60">60</option>
                        <option value="90">90</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Tipo de jornada</label>
                      <select v-model="dataSearch.journey">
                        <option value="">Selecione</option>
                        <option value="0">Trial</option>
                        <option value="1">Onboarding</option>
                        <option value="2">Middle</option>
                        <option value="3">Ongoing</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="company">Responsável</label>
                      <select v-model="dataSearch.owner">
                        <option selected value="">Selecione</option>
                        <option v-for="(value, index) in dataSelectResponsibles" :key="index" :value="value">
                          {{ value }}
                        </option>
                      </select>
                    </div>
                  </div>

                </div>
                <div class="col-md-12">
                  <button v-on:click="searchNps(1)">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="
                !loading && dataNps !== '' && !dataNps.length && !failRequest
              " class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  content-default
                ">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataNps.length" class="col-xs-12 col-sm-12 col-md-12">

              <div class="col-xs-12 col-sm-4 col-md-4" style="padding-left: 0">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL DETRATOR <span>{{ dataNpsTotal.totalDefractors }}</span></p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL NEUTRO <span>{{ dataNpsTotal.totalNeutral }}</span></p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4 col-md-4" style="padding-right: 0">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box total-dnp">
                  <p>TOTAL PROMOTOR <span>{{ dataNpsTotal.totalPromoters }}</span></p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <a v-on:click="downloadExcel()" class="btn-all-excel right" title="Imprimir">
                  <span>Gerar Excel</span>
                  <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                </a>

                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Quantidade total de nps ({{ qtdTotal }})
                    </span>
                    <span class="media-nps">Média de NPS:
                    <span>{{ averange.toFixed(2) }}</span></span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>EMPRESA</th>
                        <th>FUNCIONÁRIOS</th>
                        <th>LT</th>
                        <th>NOTA</th>
                        <th>MENSAGEM</th>
                        <th>DT DE CRIAÇÃO</th>
                        <th>Responsável</th>
                        <th>CONTATO REALIZADO</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(a, index) in dataNps" :key="index">
                        <td>
                          <a v-bind:href="
                                '/detalhes-da-empresa/' +
                                a.companyId +
                                '/' +
                                a.contentSetting
                              " target="_blank" class="link">{{ a.companyName }}</a>
                        </td>
                        <td>{{ a.totalEmployee }}</td>
                        <td>{{ a.lt }}</td>
                        <td>{{ a.rating }}</td>
                        <td>{{ a.message }}</td>
                        <td>{{ a.createdAt }}</td>
                        <td>{{ a.name }}</td>
                        <td class="td-contact">
                          <a v-if="a.contactDone === false" class="disabled-tag" @click="registerContact(a)">Não</a>
                          <a v-else class="active-tag" @click="registerContact(a)">Sim</a>
                        </td>
                        <td class="delete-nps">
                          <button @click="openDeleteNps(a)">Excluir</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Pagination -->
                <paginate v-if="totalPages > 1" v-model="pageNumber" :page-count="totalPages" :click-handler="searchNps"
                          :prev-text="'Anterior'" :next-text="'Próximo'" :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import inputText from "../../components/inputs/inputText.vue";
import swal from "sweetalert";

import {
  COMPANY_NPS,
  CHANGE_NPS, CHANGE_TICKETS_FILTERS, GET_SELECT_RESPONSIBLES
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import moment from "moment";
import datepicker from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import modalOpenContact from "../../modals/modalOpenContact.vue";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import ModalDefault from "../../components/modals/modalDefault.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import ModalPassword from "../../modals/modalPassword.vue";

export default {
  name: "all-nps",
  components: {
    ModalPassword,
    BtnCustom,
    ModalDefault,
    topMenu,
    datepicker,
    pageHeader,
    fullLoading,
    modalOpenContact,
    inputText,
  },
  data() {
    return {
      loading: false,
      failRequest: false,
      averange: "",
      ptBR: ptBR,
      dataCountNps: "",
      dataNps: "",
      dataNpsTotal: "",
      dataNpsAll: "",
      pageNumber: 1,
      pageQtd: 20,
      dataCompanyModal: "",
      totalPages: 0,
      dataSelectResponsibles: '',
      dataSearch: {
        noteType: "",
        clientBase: "",
        journey: "",
        init: "",
        end: "",
        companyId: "",
        contentSetting: "",
        rating: "",
        minRating: "",
        daysAnswered: "",
        contactDone: "",
        id: "",
        contactText: "",
        userId: "",
        owner: "",
      },
      dataRemoveNps: {},
    };
  },
  methods: {
    openDeleteNps(value) {
      this.dataRemoveNps = value;
      $('#password-modal').modal();
    },
    removeNps(password) {
      const passwordCS = 'equipeCS@2023';
      if (password === passwordCS) {
        let obj = {
          npsId: this.dataRemoveNps.id,
          companyId: this.dataRemoveNps.companyId,
          contentSetting: this.dataRemoveNps.contentSetting
        }

        UTIL_SERVICE.console("Data send: ", obj);
        REQUEST_SERVICE.post(COMPANY_NPS, obj).then((response) => {
          UTIL_SERVICE.console("NPS REMOVE", response);
          swal("Aviso", "Nota de NPS removida com sucesso.", "success");
          setTimeout(() => {
            location.reload();
          }, 1300)
        }).catch(reason => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros)
        })
      } else {
        swal("Aviso", "A senha está incorreta!", "error");
      }
    },
    registerContact(value) {
      this.dataCompanyModal = {};
      this.dataCompanyModal.companyName = value.companyName;
      this.dataCompanyModal.id = value.id;
      this.dataCompanyModal.contactText = value.contactText;
      this.dataCompanyModal.companyId = value.companyId;
      this.dataCompanyModal.contactDone = value.contactDone;
      this.dataCompanyModal.context = value.contentSetting;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalOpenContact").modal();
    },

    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchNpsExcel() {
      let urlExcel = COMPANY_NPS + "?t=kkkk";
      urlExcel += "&pageNumber=" + this.pageNumber + "&pageQtd=" + this.dataCountNps;

      if (this.dataSearch.companyId)
        urlExcel += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.init)
        urlExcel += "&dtInit=" + moment(this.dataSearch.init).format("YYYY-MM-DD");

      if (this.dataSearch.end)
        urlExcel += "&dtEnd=" + moment(this.dataSearch.end).format("YYYY-MM-DD");

      if (this.dataSearch.rating)
        urlExcel += "&rating=" + this.dataSearch.rating;

      if (this.dataSearch.minRating)
        urlExcel += "&minRating=" + this.dataSearch.minRating;

      if (this.dataSearch.daysAnswered)
        urlExcel += "&daysAnswered=" + this.dataSearch.daysAnswered;

      if (this.dataSearch.noteType)
        urlExcel += "&npsNoteFilter=" + this.dataSearch.noteType;

      if (this.dataSearch.clientBase)
        urlExcel += "&timeClientBase=" + this.dataSearch.clientBase;

      if (this.dataSearch.journey)
        urlExcel += "&clientJourneyFilter=" + this.dataSearch.journey;

      if (this.dataSearch.userId)
        url += "&userId=" + this.dataSearch.userId;


      REQUEST_SERVICE.requestContext("GET", urlExcel, this.dataSearch.header)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_NPS:", response.data);

          this.dataNpsAll = response.data.list;
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getSelectResponsibles() {
      REQUEST_SERVICE.get(GET_SELECT_RESPONSIBLES).then((response) => {
        UTIL_SERVICE.console("RESULT GET_SELECT_RESPONSIBLES:", response.data);

        this.dataSelectResponsibles = response.data
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    searchNps(type) {
      this.loading = true;

      if (type === 1) {
        this.pageNumber = 1;
      }

      let url = COMPANY_NPS + "?t=kkkk";
      url += "&pageNumber=" + this.pageNumber + "&pageQtd=" + this.pageQtd;

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      if (this.dataSearch.init)
        url += "&dtInit=" + moment(this.dataSearch.init).format("YYYY-MM-DD");

      if (this.dataSearch.end)
        url += "&dtEnd=" + moment(this.dataSearch.end).format("YYYY-MM-DD");

      if (this.dataSearch.rating)
        url += "&rating=" + this.dataSearch.rating;

      if (this.dataSearch.minRating)
        url += "&minRating=" + this.dataSearch.minRating;

      if (this.dataSearch.daysAnswered)
        url += "&daysAnswered=" + this.dataSearch.daysAnswered;

      if (this.dataSearch.noteType)
        url += "&npsNoteFilter=" + this.dataSearch.noteType;

      if (this.dataSearch.clientBase)
        url += "&timeClientBase=" + this.dataSearch.clientBase;

      if (this.dataSearch.journey)
        url += "&clientJourneyFilter=" + this.dataSearch.journey;

      if (this.dataSearch.userId)
        url += "&userId=" + this.dataSearch.userId;

      if (this.dataSearch.owner)
        url += "&owner=" + this.dataSearch.owner;


      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url, this.dataSearch.header)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);

          this.averange = response.data.averange;
          this.dataNps = response.data.list;
          this.dataNpsTotal = response.data
          this.dataCountNps = response.data.count

          this.qtdTotal = response.data.count;
          this.totalPages = Math.ceil(response.data.count / this.pageQtd);

          this.loading = false;
          this.failRequest = false;

          this.searchNpsExcel();
        })
        .catch((reason) => {
          this.loading = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    downloadExcel() {
      let bodyValue = [];
      let headValue = ["Empresa", "ID da empresa", "ID do usuário", "Funcionários", "LT", "Nota", "Mensagem", "Data de criação", "Responsável", "Contato realizado"];
      let contact = ''

      this.dataNpsAll.map((value) => {
        if (value.contactDone === true) {
          contact = 'Sim'
        } else {
          contact = 'Não'
        }

        bodyValue.push([value.companyName, value.companyId, value.userId, value.totalEmployee, value.lt, value.rating, value.message, value.createdAt, value.name, contact]);
      });

      window.downloadListExcel(headValue, bodyValue, "Lista de cancelamentos");
    },
  },
  watch: {
    dataRemoveNps(value) {
      this.openDeleteNps(value);
    }
  },
  beforeMount() {
    this.searchNps();
    this.getSelectResponsibles();
  },
};
</script>

<style lang="scss">

.total-dnp {
  p {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-weight: 400;
    font-size: 18px;

    span {
      font-size: 26px;
      margin-top: 5px;
      font-weight: 500;
    }
  }
}

.media-nps {
  display: block;
  margin-top: 20px;
  color: #3598dc !important;
  font-weight: bold;
  text-transform: uppercase;

  span {
    font-size: 22px;
  }
}

.input-with-date {
  width: 100%;
}

.vdp-datepicker {
  input {
    width: 100%;
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  margin-top: 0;
  border: none;
  font-weight: 700;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.right {
  float: right;
}

.td-contact {
  width: 60px;
}

.active-tag {
  background: #00a651;
  color: #ffffff;
  display: block;
  width: 100%;
  text-align: center;
  border-radius: 4px !important;
  height: 24px;
  padding: 0 10px;
  line-height: 25px;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
}

.disabled-tag {
  background: #e8505b;
  color: #ffffff;
  display: block;
  width: 100%;
  text-align: center;
  border-radius: 4px !important;
  height: 24px;
  padding: 0 10px;
  line-height: 25px;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
}

.delete-nps {
  width: 40px;

  button {
    background: #ffffff;
    padding: 1px 6px;
    border-radius: 3px !important;
    border: 1px solid rgba(0, 0, 0, .2);

    &:hover {
      border-color: #E7505A;
      color: #FFF;
      background-color: #E7505A;
    }
  }
}

.alerta {
  text-align: center;
  margin: 40px 0;

  span {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/nps/allNps.vue